module.exports = require("react-markdown");


//////////////////
// WEBPACK FOOTER
// external "react-markdown"
// module id = 527
// module chunks = 0